import React from 'react';

import { ReactComponent as TriangleAdmiration } from '../../assets/icons/TriangleAdmiration.svg';
import { ReactComponent as PencilWrite } from '../../assets/icons/PencilWrite.svg';
import { ReactComponent as Megaphone } from '../../assets/icons/Megaphone.svg';
import Button from '../Buttons/Button/Button';

import classes from './NoticeCard.module.scss';

const icon = {
  info: <Megaphone />,
  valid: <Megaphone />,
  failed: <TriangleAdmiration />
};

const NoticeCard = ({ className, text, type = 'info', editHandler, isNotButton, classNameText, textButton }) => {
  return (
    <div className={`${classes.notification} ${className ? className : classes.margin} ${classes[type]}`}>
      {icon[type]}
      <div className={`${type === 'failed' ? classes.text : ''} ${classNameText}`}>
        <span className='medium-16'>{text}</span>
        {type === 'failed' && !isNotButton && (
          <Button onClick={editHandler} custom='quaternary' Icon={PencilWrite}>
            {textButton ? textButton : 'Verificar información'}
          </Button>
        )}
      </div>
    </div>
  );
};

export default NoticeCard;
